import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Message = _resolveComponent("Message")
  const _component_Column = _resolveComponent("Column")
  const _component_Menu = _resolveComponent("Menu")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_SchedulerTimingOutputInfoDialog = _resolveComponent("SchedulerTimingOutputInfoDialog")
  const _component_SchedulerTimingOutputDetailDialog = _resolveComponent("SchedulerTimingOutputDetailDialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('managers.scheduler.timingAndOutput')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "kn-button p-button-text p-button-rounded",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTriggerDetail(null)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.add')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.triggers.length === 0)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          class: "p-m-4",
          severity: "info",
          closable: false,
          style: _ctx.schedulerTimingOutputTableDescriptor.styles.message
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.scheduler.noTriggersInfo')), 1)
          ]),
          _: 1
        }, 8, ["style"]))
      : (_openBlock(), _createBlock(_component_DataTable, {
          key: 1,
          id: "triggers-datatable",
          value: _ctx.triggers,
          paginator: true,
          rows: _ctx.schedulerTimingOutputTableDescriptor.rows,
          class: "p-datatable-sm kn-table p-m-2",
          dataKey: "triggerName",
          responsiveLayout: _ctx.schedulerTimingOutputTableDescriptor.responsiveLayout,
          breakpoint: _ctx.schedulerTimingOutputTableDescriptor.breakpoint,
          rowClass: _ctx.rowClass
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              class: "kn-truncated",
              header: _ctx.$t('common.name')
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("span", null, _toDisplayString(slotProps.data.triggerName), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              class: "kn-truncated",
              header: _ctx.$t('common.type')
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.triggerChronType), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              class: "kn-truncated",
              header: _ctx.$t('cron.startDate')
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.getFormatedDate(slotProps.data.triggerZonedStartTime, 'DD/MM/YYYY HH:mm')), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              class: "kn-truncated",
              header: _ctx.$t('cron.endDate')
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.triggerZonedEndTime ? _ctx.getFormatedDate(slotProps.data.triggerZonedEndTime, 'DD/MM/YYYY HH:mm') : ''), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              class: "kn-truncated",
              header: _ctx.$t('common.paused')
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.triggerIsPaused ? _ctx.$t('common.yes') : _ctx.$t('common.no')), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              style: _ctx.schedulerTimingOutputTableDescriptor.iconColumnStyle
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_Button, {
                  class: "p-button-link p-button-sm",
                  icon: "fa fa-ellipsis-v",
                  onClick: ($event: any) => (_ctx.toggle($event, slotProps.data)),
                  "aria-haspopup": "true",
                  "aria-controls": "overlay_menu"
                }, null, 8, ["onClick"]),
                _createVNode(_component_Menu, {
                  ref: "menu",
                  model: _ctx.items,
                  popup: true,
                  "data-test": "menu"
                }, null, 8, ["model"]),
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-link",
                  onClick: ($event: any) => (_ctx.deleteTriggerConfirm({ trigger: slotProps.data, index: slotProps.index }))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["value", "rows", "responsiveLayout", "breakpoint", "rowClass"])),
    _createVNode(_component_SchedulerTimingOutputInfoDialog, {
      visible: _ctx.triggerInfoDialogVisible,
      triggerInfo: _ctx.triggerInfo,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.triggerInfoDialogVisible = false))
    }, null, 8, ["visible", "triggerInfo"]),
    _createVNode(_component_SchedulerTimingOutputDetailDialog, {
      visible: _ctx.triggerDetailDialogVisible,
      propTrigger: _ctx.triggerInfo,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.triggerDetailDialogVisible = false)),
      onSaved: _ctx.onSave
    }, null, 8, ["visible", "propTrigger", "onSaved"])
  ]))
}